export default "__VITE_ASSET__40644a3e__"